<template>
  <div class="block-form">
    <div class="form-field">
      <div class="form-label">Nivel</div>
      <q-btn-toggle
        :model-value="block.level"
        :options="levelOptions"
        unelevated
        dense
        no-caps
        toggle-color="primary"
        @update:model-value="emit('update', { ...block, level: $event })"
      />
    </div>
    <q-input
      outlined
      :model-value="block.text"
      label="Texto"
      @update:model-value="emit('update', { ...block, text: $event })"
    />
  </div>
</template>

<script setup lang="ts">
interface HeadingBlock {
  type: 'heading';
  level: 1 | 2 | 3;
  text: string;
}

const props = defineProps<{ block: HeadingBlock }>();
const emit = defineEmits<{ (e: 'update', block: HeadingBlock): void }>();

const levelOptions = [
  { label: 'H1', value: 1 },
  { label: 'H2', value: 2 },
  { label: 'H3', value: 3 },
];

// props used via template
void props;
</script>

<style scoped lang="scss">
.block-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}
.form-label {
  font-size: 13px;
  color: var(--oa-text-muted);
  margin-bottom: 6px;
}
</style>
